<template>
	<div class="flow-shimmer" :style="styleObj" />
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { CSSProperties } from "vue/types/jsx";

export default defineComponent({
	name: "Shimmer",
	props: {
		width: {
			type: String as PropType<CSSProperties["width"]>,
			default: "100%"
		},
		height: {
			type: String as PropType<CSSProperties["height"]>,
			default: "100%"
		}
	},
	computed: {
		styleObj(): CSSProperties {
			return {
				width: this.width,
				height: this.height
			};
		}
	}
});
</script>
<style lang="scss">
div.flow-shimmer {
	display: flex;
	min-height: 12px;
	// height: 100%;
	// width: 100%;

	background: var(--dashboard-background);
	background-image: linear-gradient(
		to right,
		var(--dashboard-background) 0%,
		var(--gray-500) 20%,
		var(--gray-400) 50%,
		var(--gray-500) 60%,
		var(--dashboard-background) 100%
	);
	background-repeat: no-repeat;
	background-size: 200px 100%;
	animation-duration: 1.5s;
	animation-fill-mode: forwards;
	animation-iteration-count: infinite;
	animation-name: placeholderShimmer;
	animation-timing-function: linear;
	@keyframes placeholderShimmer {
		0% {
			background-position: -200px 0%;
		}

		100% {
			background-position: 200px 0%;
		}
	}
}
</style>
